import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-507bf207")

_pushScopeId("data-v-507bf207")
const _hoisted_1 = { class: "flex flex-col items-center" }
const _hoisted_2 = { class: "flex justify-center mb-2" }
const _hoisted_3 = { class: "text-14px font-semibold text-gray-lp-300 text-center" }
const _hoisted_4 = { class: "text-24px font-bold text-red-lp-300 mb-2 text-center tracking-wide underline" }
const _hoisted_5 = { class: "w-full mb-8 border border-gray-lp-2100 rounded-xl overflow-hidden" }
const _hoisted_6 = { class: "table-container" }
const _hoisted_7 = { class: "table-invoice w-full border-collapse" }
const _hoisted_8 = {
  class: "text-left py-4 px-5 text-14px font-semibold text-gray-lp-300 border-b border-gray-lp-2100",
  style: {"width":"15%"}
}
const _hoisted_9 = {
  class: "text-left py-4 px-5 text-14px font-semibold text-gray-lp-300 border-b border-gray-lp-2100",
  style: {"width":"35%"}
}
const _hoisted_10 = {
  class: "text-left py-4 px-5 text-14px font-semibold text-gray-lp-300 border-b border-gray-lp-2100",
  style: {"width":"25%"}
}
const _hoisted_11 = {
  class: "text-left py-4 px-3 text-14px font-semibold text-gray-lp-300 border-b border-gray-lp-2100",
  style: {"width":"25%"}
}
const _hoisted_12 = { class: "table-body-wrapper" }
const _hoisted_13 = { class: "w-full border-collapse" }
const _hoisted_14 = {
  class: "py-4 px-5 text-14px text-gray-700",
  style: {"width":"15%"}
}
const _hoisted_15 = {
  class: "py-4 px-5 text-14px text-gray-700",
  style: {"width":"35%"}
}
const _hoisted_16 = {
  class: "py-4 px-5 text-14px text-gray-700",
  style: {"width":"25%"}
}
const _hoisted_17 = {
  class: "py-4 px-5 text-14px text-gray-700",
  style: {"width":"25%"}
}
const _hoisted_18 = { class: "w-full" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modelValue: _ctx.isShowModalSuccess,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowModalSuccess = $event)),
    persistent: true,
    title: '',
    class: "success-send-invoice-modal",
    header: false
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("img", {
            src: require('@/app/ui/assets/svg/badge-success.svg'),
            alt: "success",
            class: "w-100px h-100px"
          }, null, 8, ["src"])
        ]),
        _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("tagihan.modal.successSendTitle")), 1),
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.invoiceNo), 1),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("table", _hoisted_7, [
              _createVNode("thead", null, [
                _createVNode("tr", null, [
                  _createVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("tagihan.table.no")) + ". ", 1),
                  _createVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("tagihan.modal.sendTo")), 1),
                  _createVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("tagihan.modal.via")), 1),
                  _createVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("tagihan.modal.format")), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("table", _hoisted_13, [
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.recipients, (recipient, index) => {
                    return (_openBlock(), _createBlock("tr", {
                      key: index,
                      class: { 'border-b border-gray-lp-2100': index !== _ctx.recipients.length - 1 }
                    }, [
                      _createVNode("td", _hoisted_14, _toDisplayString(index + 1), 1),
                      _createVNode("td", _hoisted_15, _toDisplayString(recipient.send_to_masked), 1),
                      _createVNode("td", _hoisted_16, _toDisplayString(_ctx.formatVia(recipient.via)), 1),
                      _createVNode("td", _hoisted_17, _toDisplayString(_ctx.formatType(recipient.format_display)), 1)
                    ], 2))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
            class: "w-full text-14px bg-transparent text-red-lp-300 border border-red-lp-300 font-semibold py-3 px-8 rounded-lg hover:bg-red-lp-100 hover:text-white transition-colors duration-200"
          }, _toDisplayString(_ctx.$t("tagihan.modal.close")), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})